export default __webpack_public_path__ + "static/mini-hero-internet-f42be2f542d8b5858962faf20043aac6.jpg";